import { render, staticRenderFns } from "./CardSelectField.vue?vue&type=template&id=4c0a0d18&scoped=true&"
import script from "./CardSelectField.vue?vue&type=script&lang=js&"
export * from "./CardSelectField.vue?vue&type=script&lang=js&"
import style0 from "./CardSelectField.vue?vue&type=style&index=0&id=4c0a0d18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0a0d18",
  null
  
)

export default component.exports